import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { RideAdjustmentApiResponse, RideAdjustmentData } from "./RideAdjustmentType";
import "../../css/RideAdjustment.css";
import { axiosSettings } from "../../axios/axios";

const RideAdjustment: React.FC = () => {
  type Item = {
    ride_id: string;
  };
  const location = useLocation();
  const item = location.state as Item;

  const [rideAdjustment, setRideAdjustment] = useState<RideAdjustmentData[] | null>(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRefundClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsModulateModalOpen(false);
  };

  const [isModulateModalOpen, setIsModulateModalOpen] = useState(false);

  const handleModulateClick = () => {
    setIsModulateModalOpen(true);
  };

  const history = useHistory();

  const handleBackClick = () => {
    history.goBack();
  };

  const [isRefundCompleteModalOpen, setIsRefundCompleteModalOpen] = useState(false);

  const handleRefundCompleteClick = () => {
    setIsRefundCompleteModalOpen(true);
  };

  const handleCloseRefundCompleteModal = () => {
    setIsRefundCompleteModalOpen(false);
  };

  const handleCloseAllModals = () => {
    setIsModalOpen(false);
    setIsRefundCompleteModalOpen(false);
    setIsModulateModalOpen(false);
  };

  return (
    <div className="ride-box">
      <h2 className="ride-title" onClick={handleBackClick} style={{ cursor: "pointer" }}>＜ ライド調整</h2>
      <div className="ride-container"> 
        <div className="ride-adjustment">
          <div className="form-group">
            <label>利用開始日時</label>
            <div className="input-group">
              <i className="far fa-calendar-alt fa-lg"></i>
              <input type="date" value="2024-07-11" />
              <i className="far fa-clock fa-lg"></i>
              <input type="time" value="03:24:06" />
            </div>
          </div>
          <div className="form-group">
            <label>支払い料金</label>
            <div className="input-group">
              <input type="number" value="185"/>
              <span>円</span>
              <button>再計算</button>
            </div>
          </div>
          <div className="form-group">
            <label>ユーザーステータス</label>
            <select>
              <option>未払い</option>
              <option>正常</option>
              <option>個人情報登録済み</option>
              <option>アカウント登録済み</option>
              <option>利用禁止</option>
            </select>
          </div>
        </div>
        
        <div className="ride-adjustment">
          <div className="form-group">
            <label>利用終了日時</label>
            <div className="input-group">
              <i className="far fa-calendar-alt fa-lg"></i>
              <input type="date" value="2024-07-11" />
              <i className="far fa-clock fa-lg"></i>
              <input type="time" value="03:34:00"/>
            </div>
          </div>
          <div className="form-group">
            <label>支払い方法</label>
            <p>PayPay</p>
          </div>
          <div className="form-group">
            <label>返金対応</label>
            <p>-</p>
          </div>
        </div>
      </div> 
      <div className="buttons">
        <button onClick={handleRefundClick}>返金</button>
        <button onClick={handleModulateClick}>ライド調整</button>
        <button　onClick={handleBackClick} style={{ cursor: "pointer" }}>キャンセル</button>
      </div>

      {isModalOpen && (
        <div className="ride-modal">
          <div className="modal-content">
            <button className="close" onClick={handleCloseAllModals}>
              &times;
            </button>
            <div className="modal-content-inner">
              <h2>返金対応</h2>
              <p>ライド料金：140円</p>
              <p>利用開始日時：2024年07月11日 03:24:06</p>
              <p>利用終了日時：2024年07月11日 03:34:56</p>
              <div className="form-group">
                <label>返金日</label>
                <i className="far fa-calendar-alt fa-lg"></i>
                <input type="date" value="2024-07-11" className="modal-input-date"/>
              </div>
              <div className="form-group">
                <label>メモ</label>
                <input type="text" placeholder="メモを入力" className="modal-input-memo"/>
              </div>
              <div className="modal-buttons">
                <button onClick={handleRefundCompleteClick}>全額返金</button>
                <button onClick={handleRefundCompleteClick}>分割返金</button>
                <button onClick={handleCloseAllModals}>キャンセル</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isRefundCompleteModalOpen && (
        <div className="ride-modal">
          <div className="modal-content">
            <button className="close" onClick={handleCloseAllModals}>
              &times;
            </button>
            <div className="modal-content-inner-complete">
              <div className="modal-content-inner-complete-inner">
                <h2>返金対応が完了しました</h2>
                <p>ライド料金：410円</p>
                <p>利用開始日：2024年07月11日 03:24:06</p>
                <p>利用終了日：2024年07月11日 03:49:56</p>
              </div>
              <button onClick={handleCloseAllModals}>閉じる</button>
            </div>
          </div>
        </div>
      )}

      {isModulateModalOpen && (
        <div className="ride-modal">
          <div className="modal-content height380">
            <button className="close" onClick={handleCloseAllModals}>
              &times;
            </button>
            <div className="modal-content-inner">
              <h2>ライド調整</h2>
              <p>ライド時刻と料金を以下の様に調整します。</p>
              <p>支払い料金：185円</p>
              <p>利用開始日：2024年07月11日 03:24:06</p>
              <p>利用終了日：2024年07月11日 03:34:00</p>
              <p>ユーザーステータス：未払い</p>
              <div className="modal-buttons">
                <button onClick={handleCloseAllModals}>確定</button>
                <button onClick={handleCloseAllModals}>キャンセル</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RideAdjustment;